import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
import Loading from '@/components/widgets/Loading.vue'

export default {
  components: {
    Loading
  },
  mixins: [validationMixin],
  validations: {
    company_name: { required },
    phone_number: { required },
    address: { required }
  },
  data() {
    return {
      loading: false,
      busy: false,
      company_name: null,
      tax_number: null,
      address: null,
      phone_number: null,
      fax_number: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.onInitData()
    })
  },
  methods: { 
    async onInitData() {
      try {
        this.busy = true
        this.loading = true
        const result = await this.$store.dispatch('Setting/get', { root: true })
        setTimeout(() => {
          this.busy = false
          this.loading = false
          if (result && result.status === 200 && result.data) {
            // ข้อมูลเก่าอาจเคยถูกบันทึกเป็นข้อความ "null" — แสดงเป็นช่องว่าง
            const clean = v => (v === null || v === undefined || v === 'null') ? '' : v
            this.company_name = clean(result.data.company_name)
            this.tax_number = clean(result.data.tax_number)
            this.address = clean(result.data.address)
            this.phone_number = clean(result.data.phone_number)
            this.fax_number = clean(result.data.fax_number)
          }
        }, 500)
      } catch (error) {
        this.busy = false
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async onSubmitForm() {
      try {
        this.loading = true
        this.$v.$touch()
        if (this.$v.$anyError) {
          this.loading = false
          return
        }
        // FormData แปลง null เป็นข้อความ "null" แล้วไปพิมพ์บนเอกสาร — ข้ามช่องที่เป็น null
        const formData = new FormData()
        const fields = ['company_name', 'tax_number', 'address', 'phone_number', 'fax_number']
        fields.forEach(key => {
          if (this[key] !== null && this[key] !== undefined) formData.append(key, this[key])
        })

        await this.$axios.post(this.$host + "/api/v1/setting/company", 
        formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })

        this.loading = false
        this.$swal({
          width: "29rem",
          padding: '1.825em',
          html: '<div class="d-flex flex-row align-items-center">' +
            '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
            '<div class="d-flex flex-column">'+
            '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>'+
            '<span class="text-base text-left text-gray-500">บันทึกข้อมูลเรียบร้อยแล้ว</span>'+
            '</div>'+
          '</div>',
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              popup: 'swal2-custom-rounded',
              closeButton: 'text-3xl swal2-custom-close',
              actions: 'justify-content-end',
              contant: 'd-flex flex-row justify-content-around px-2',
              title: 'd-none',
              confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
              cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
            },
            showCancelButton: false,
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก",
            showCloseButton: true,
        }).then(result => { })
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }      
    }
  }
}
